export function clearUrlProtocol(url: string): string {
  // Remove the protocol (http:// or https://)
  let convertedUrl = url.replace(/(^\w+:|^)\/\//, '')

  // Remove any trailing slash
  convertedUrl = convertedUrl.replace(/\/$/, '')

  return convertedUrl
}
